// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__KdoaV","footer":"Footer_footer__fqCOY","copyright":"Footer_copyright__+pElU","version":"Footer_version__pKp+m"};